import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { packItems, volumes, volumesIntro } from '../data/hockey';
export function WhatsInside() {
  const [active, setActive] = useState<number>(0);
  const volume = volumes[active];
  const hasDetails = Boolean(volume.items && volume.items.length > 0);
  return <section id="inside" className="w-full bg-stone-50 px-8 py-24 sm:px-14 sm:py-32" data-id="element-302" data-mp="b6g6wfa199lm">
      <div className="mx-auto max-w-6xl" data-id="element-303" data-mp="b4ljmubah5ed">
        <h2 className="mx-auto max-w-3xl text-center font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-304" data-mp="fxel99bgnxm8">
          What’s Inside <em className="text-red-700" data-id="element-305" data-mp="23ng0d4rizwb">HOCKEY READY™</em>?
        </h2>

        <div className="mt-16 grid gap-6 lg:grid-cols-12 lg:items-end" data-id="element-306" data-mp="75cphocc75ia">
          <h3 className="font-serif text-3xl leading-tight text-slate-900 sm:text-4xl lg:col-span-6" data-id="element-307" data-mp="3ocomkf7j0ysy">
            {volumesIntro.title}
          </h3>
          <p className="text-lg leading-relaxed text-slate-900/75 lg:col-span-6" data-id="element-308" data-mp="3te5irxf2fx37">{volumesIntro.text}</p>
        </div>

        <div role="tablist" aria-label="Volumes" className="mt-10 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6" data-id="element-309" data-mp="37utbs80pkjd7">
          {volumes.map((item, index) => {
          const isActive = index === active;
          return <button key={item.number} type="button" role="tab" id={`volume-tab-${index}`} aria-selected={isActive} aria-controls="volume-panel" onClick={() => setActive(index)} className={`flex h-56 flex-col rounded-lg border-r-8 border-black/10 p-4 text-left shadow-xl shadow-slate-900/20 transition-[transform,opacity] duration-200 ease-out focus:outline-none focus-visible:ring-4 focus-visible:ring-red-700/40 sm:h-64 lg:h-72 ${item.spine} ${isActive ? '-translate-y-2' : 'opacity-75 hover:-translate-y-1 hover:opacity-100'}`} data-id="element-310" data-mp="3hsh995pp84z2" data-mpi={index}>
                <span className="text-xs font-semibold opacity-80" data-id="element-311" data-mp="2ae4cakz8dt6z">Volume</span>
                <span className="mt-1 font-serif text-3xl leading-none" data-id="element-312" data-mp="26en4hkwc0jyn">{item.number.replace('Volume ', '')}</span>
                <span className={`mt-auto border-t pt-3 text-sm font-medium leading-snug ${item.rule}`} data-id="element-313" data-mp="9cg21dstqh8t">
                  {item.title}
                </span>
              </button>;
        })}
        </div>

        <div id="volume-panel" role="tabpanel" aria-labelledby={`volume-tab-${active}`} className="mt-8 border-t border-slate-900/15 pt-10" data-id="element-314" data-mp="j4c22ueh0hfo">
          <AnimatePresence mode="wait" initial={false} data-id="element-315" data-mp="3mjr71h7zs0ty">
            <motion.div key={volume.number} initial={{
            opacity: 0,
            y: 6
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -6
          }} transition={{
            duration: 0.18,
            ease: [0.23, 1, 0.32, 1]
          }} className="grid gap-10 lg:grid-cols-12" data-id="element-316" data-mp="3mlanb7tnebvq">
              {hasDetails ? <>
                  <div className="lg:col-span-5" data-id="element-317" data-mp="1br6fj7cvegjn">
                    <p className="text-sm font-semibold text-red-700" data-id="element-318" data-mp="1gqj6o4ary9s1">
                      {volume.number} · {volume.title}
                    </p>
                    <h4 className="mt-2 font-serif text-3xl leading-tight text-slate-900 sm:text-4xl" data-id="element-319" data-mp="3180nd84cfwhe">{volume.heading}</h4>
                    <p className="mt-4 text-lg leading-relaxed text-slate-900/80" data-id="element-320" data-mp="2wc38754tgw67">{volume.intro}</p>
                    {volume.cover && <img src={volume.cover} alt={`${volume.number} — ${volume.title} cover`} loading="lazy" className="mt-8 w-full max-w-[220px] rounded-md shadow-2xl shadow-slate-900/30" data-id="element-321" data-mp="2mk76zl7fopxr" />}
                  </div>
                  <div className="lg:col-span-7" data-id="element-322" data-mp="2dipuect8j6dt">
                    <p className="text-sm font-semibold text-slate-900/60" data-id="element-323" data-mp="2dhy0r7j77iq6">Includes:</p>
                    <ul className="mt-4 grid gap-x-8 gap-y-3 sm:grid-cols-2" data-id="element-324" data-mp="28ko9dmc90wzp">
                      {volume.items?.map(entry => <li key={entry} className="flex gap-3 text-[15px] leading-snug text-slate-900/80" data-id="element-325" data-mp="23mw8i2tmm0jd">
                          <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-red-700" strokeWidth={2.5} aria-hidden="true" data-id="element-326" data-mp="6qp0f7mlmrq6" />
                          {entry}
                        </li>)}
                    </ul>
                    {volume.outro && <p className="mt-6 font-serif text-xl italic leading-snug text-slate-900/80" data-id="element-327" data-mp="2zmzzerotvab4">{volume.outro}</p>}
                  </div>
                </> : <div className="lg:col-span-8" data-id="element-328" data-mp="2lmpc1ymq8dup">
                  <p className="text-sm font-semibold text-red-700" data-id="element-329" data-mp="2qmlgu03909bb">{volume.number}</p>
                  <h4 className="mt-2 font-serif text-3xl leading-tight text-slate-900 sm:text-4xl" data-id="element-330" data-mp="2qoen3e9y8ris">{volume.title}</h4>
                  <p className="mt-4 text-lg leading-relaxed text-slate-900/80" data-id="element-331" data-mp="2go5nrrknupz6">{volume.description}</p>
                </div>}
            </motion.div>
          </AnimatePresence>
        </div>

        <div className="mt-24 border-t border-slate-900/15 pt-12" data-id="element-332" data-mp="27w3q211z7nsl">
          <div className="grid gap-6 lg:grid-cols-12 lg:items-end" data-id="element-333" data-mp="27wc07l6psf03">
            <h3 className="font-serif text-3xl leading-tight text-slate-900 sm:text-4xl lg:col-span-6" data-id="element-334" data-mp="1szusr51nbkit">
              What Makes HOCKEY READY™ Different?
            </h3>
            <p className="text-lg leading-relaxed text-slate-900/75 lg:col-span-6" data-id="element-335" data-mp="1ebunwyyavrj7">
              Other resources talk to the player. This one is built for the coach — a whole field
              hockey season, organized and ready to run.
            </p>
          </div>
          <ul className="mt-12 grid gap-x-10 gap-y-12 sm:grid-cols-2 lg:grid-cols-3" data-id="element-336" data-mp="1o87l46t20nip">
            {packItems.map(item => {
            const Icon = item.icon;
            return <li key={item.title} data-id="element-337" data-mp="1x9nr82cu63h4">
                  <Icon className="h-6 w-6 text-red-700" strokeWidth={1.75} aria-hidden="true" data-id="element-338" data-mp="1x8m61523w0lo" />
                  <h4 className="mt-4 font-serif text-2xl leading-tight text-slate-900" data-id="element-339" data-mp="1t7kelaefksu9">{item.title}</h4>
                  <p className="mt-2 text-sm leading-relaxed text-slate-900/70" data-id="element-340" data-mp="221p1jiqg1k4i">{item.text}</p>
                </li>;
          })}
          </ul>
        </div>
      </div>
    </section>;
}